module.exports = __webpack_public_path__ + "img/ruoyi20-jk.ae9f8efe.png";